export const SHOW_TP_MODAL = 'show_tp_modal';

export function tpShowModalEmitter(divId) {
  try {
    const logoutEvent = new CustomEvent(SHOW_TP_MODAL, {
      detail: { elementId: divId },
    });
    window.dispatchEvent(logoutEvent);
  } catch (e) {
    // console.log(e);
  }
}
